export class ElectricGate {
    constructor(x, y, vertical = true) {
        this.x = x;
        this.y = y;
        this.vertical = vertical;
        this.width = vertical ? 20 : 100;
        this.height = vertical ? 100 : 20;
        this.active = false;
        this.cooldown = 0;
        this.maxCooldown = 120; // 2 seconds
        this.zapRadius = 200;
        this.color = '#00ffff';
        this.animPhase = 0;
    }

    update() {
        this.animPhase += 0.15;

        if (this.cooldown > 0) {
            this.cooldown--;
            this.active = false;
        }
    }

    checkPlayerCollision(player) {
        const playerInGate =
            player.x > this.x - this.width / 2 &&
            player.x < this.x + this.width / 2 &&
            player.y > this.y - this.height / 2 &&
            player.y < this.y + this.height / 2;

        if (playerInGate && this.cooldown === 0) {
            this.activate();
            return true;
        }
        return false;
    }

    activate() {
        this.active = true;
        this.cooldown = this.maxCooldown;
    }

    zapEnemies(enemies, damage, particles) {
        if (!this.active) return [];

        const zapped = [];

        enemies.forEach(enemy => {
            const dx = enemy.x - this.x;
            const dy = enemy.y - this.y;
            const dist = Math.sqrt(dx * dx + dy * dy);

            if (dist < this.zapRadius) {
                enemy.takeDamage(damage);
                zapped.push(enemy);

                // Create lightning effect particles
                for (let i = 0; i < 10; i++) {
                    particles.push({
                        x: enemy.x,
                        y: enemy.y,
                        vx: (Math.random() - 0.5) * 8,
                        vy: (Math.random() - 0.5) * 8,
                        radius: Math.random() * 2 + 1,
                        color: '#00ffff',
                        life: 20,
                        maxLife: 20,
                        update() {
                            this.x += this.vx;
                            this.y += this.vy;
                            this.vx *= 0.95;
                            this.vy *= 0.95;
                            this.life--;
                            return this.life > 0;
                        },
                        draw(ctx) {
                            ctx.save();
                            ctx.globalAlpha = this.life / this.maxLife;
                            ctx.fillStyle = this.color;
                            ctx.shadowBlur = 10;
                            ctx.shadowColor = this.color;
                            ctx.beginPath();
                            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                            ctx.fill();
                            ctx.restore();
                        }
                    });
                }
            }
        });

        return zapped;
    }

    draw(ctx, player = null) {
        ctx.save();

        // Draw gate structure
        const pulse = Math.sin(this.animPhase) * 2;

        if (this.active || this.cooldown > 0) {
            ctx.shadowBlur = 30;
            ctx.shadowColor = this.color;
        } else {
            ctx.shadowBlur = 10;
            ctx.shadowColor = this.color;
        }

        // Gate frame
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 4;
        ctx.globalAlpha = 0.8;
        ctx.strokeRect(
            this.x - this.width / 2,
            this.y - this.height / 2,
            this.width,
            this.height
        );

        // Electric energy
        if (this.cooldown === 0) {
            ctx.globalAlpha = 0.3 + Math.sin(this.animPhase * 2) * 0.2;
            ctx.fillStyle = this.color;
            ctx.fillRect(
                this.x - this.width / 2,
                this.y - this.height / 2,
                this.width,
                this.height
            );
        }

        // Active zap effect
        if (this.active) {
            ctx.globalAlpha = 0.6;
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.zapRadius, 0, Math.PI * 2);
            ctx.stroke();

            // Lightning bolts to player if provided
            if (player) {
                ctx.strokeStyle = this.color;
                ctx.lineWidth = 3;
                ctx.globalAlpha = 0.8;

                for (let i = 0; i < 3; i++) {
                    ctx.beginPath();
                    ctx.moveTo(this.x, this.y);

                    let currentX = this.x;
                    let currentY = this.y;
                    const steps = 10;

                    for (let j = 0; j < steps; j++) {
                        const progress = j / steps;
                        const targetX = this.x + (player.x - this.x) * progress;
                        const targetY = this.y + (player.y - this.y) * progress;

                        currentX = targetX + (Math.random() - 0.5) * 20;
                        currentY = targetY + (Math.random() - 0.5) * 20;

                        ctx.lineTo(currentX, currentY);
                    }

                    ctx.lineTo(player.x, player.y);
                    ctx.stroke();
                }
            }
        }

        // Cooldown indicator
        if (this.cooldown > 0) {
            const cooldownPercent = this.cooldown / this.maxCooldown;
            ctx.fillStyle = '#ff0000';
            ctx.globalAlpha = 0.5;

            if (this.vertical) {
                ctx.fillRect(
                    this.x - this.width / 2,
                    this.y - this.height / 2,
                    this.width,
                    this.height * (1 - cooldownPercent)
                );
            } else {
                ctx.fillRect(
                    this.x - this.width / 2,
                    this.y - this.height / 2,
                    this.width * (1 - cooldownPercent),
                    this.height
                );
            }
        }

        ctx.restore();
    }
}
